import { useMutation } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useCreateSecureUploadLink = () => {
  const dealership = useDealership()
  return useMutation(
    ({
      data,
    }: {
      data: {
        selectedUploadType:
          | 'sales'
          | 'leads'
          | 'service'
          | 'other'
          | 'hashed-customers'
          | 'opt-out-customers'
        customer_source_id: string
      }
    }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sign_upload_link`,
        method: 'POST',
        data,
      }),
  )
}
